import queryString from 'query-string'
import { history } from "../configs/history";

export const toggleMapWindow = () => {
    const location = history.location;
    const queryParams = queryString.parse(location.search)
    const newPathname =queryParams.map ? location.pathname: `${location.pathname}?map=true`
    history.push(newPathname)
};
